export default __webpack_public_path__ + "static/ppc-awards-footer-9c16651031bf0f52c16b3c9096b6c1ad.png";